import { FAIcon, IconStyle, TextLink, TextLinkStyle, Theme } from '@nextgen-web-framework/all';
import styles from './SubHeader.module.scss';
import SubHeaderProps, { Version } from './types/propTypes';

const SubHeader = ({ headingText, actions, version = Version.V1 }: SubHeaderProps): JSX.Element => (
  <div className={styles['sub-header']}>
    <div className={styles['heading']} data-testid="heading-testid">
      {headingText}
    </div>
    {actions && (
      <div className={styles['actions']}>
        {actions.map((action) => (
          <div key={action?.icon} className={styles['heading-link-container']}>
            {action.icon && version === Version.V2 ? (
              <FAIcon
                iconName={action.icon}
                iconStyle={IconStyle.REGULAR}
                theme={Theme.PURPLE}
                className={styles['user-group-icon']}
              />
            ) : (
              <></>
            )}
            <TextLink
              key={action.text}
              data-testid="action-item-testid"
              text={action.text}
              customClass={styles['action']}
              onClick={action.callbackFunction}
              textLinkStyle={Version.V2 ? action.textLinkStyle : TextLinkStyle.UNDERLINE}
              theme={Theme.PURPLE}
            />
          </div>
        ))}
      </div>
    )}
  </div>
);

export default SubHeader;
